import { Vue } from 'vue-class-component';
import store from '/@/store/store';
import { MetaModule } from '/@/store/enums';

export default class Meta extends Vue {
	mounted() {
		this.removeOriginalMetaTags();
	}

	get meta() {
		return store.get(MetaModule.GET_META);
	}

	removeOriginalMetaTags() {
		document.querySelector('title')?.remove();
		document.querySelector('meta[name="description"]')?.remove();
		document.querySelector('meta[property="og:title"]')?.remove();
		document.querySelector('meta[property="og:description"]')?.remove();
		document.querySelector('meta[property="og:image"]')?.remove();
	}
}
